
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/__hide/surveys/user",
      function () {
        return require("private-next-pages/__hide/surveys/user/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/__hide/surveys/user"])
      });
    }
  